import { specialitiesApi } from "../../services/nomenclatures/specialitiesApi";
import { Skeleton } from "primereact/skeleton";
import FilterCard from "./FilterCard";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import Error from "../common/Error";
import { RootState } from "../../store";
import { SpecialityResponse } from "../../models/dtos";
import FilterBox from "./FilterBox";

type SpecialityFilterProps = {
  getSelectedSpecialities: (state: RootState) => SpecialityResponse[];
  setSelectedSpecialities: any;
};

const SpecialityFilter = ({ getSelectedSpecialities, setSelectedSpecialities }: SpecialityFilterProps) => {
  const selectedSpecialities = useSelector(getSelectedSpecialities);
  const dispatch = useAppDispatch();

  const { data: specialities, error, isLoading } = specialitiesApi.useGetSpecialitiesAsFlatListQuery();

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По специалност:">
      <FilterBox<SpecialityResponse>
        filter
        value={selectedSpecialities}
        onChange={(e) => {
          console.log(e);
          dispatch(setSelectedSpecialities(e.value));
        }}
        options={specialities?.data ?? []}
        optionLabel="name"
        listClassName="max-h-24rem"
        dataKey="specialityId"
      />
    </FilterCard>
  );
};

export default SpecialityFilter;
